import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Drawer, DrawerProps, IconButton, Toolbar } from '@mui/material';
import { Link } from 'react-router-dom';
import { LogoNegative } from '../../../components/Logo';
import { getConfig } from '../../../utils/config';

const { drawerWidth } = getConfig();

export const AppDrawer = ({ sx, children, ...rest }: DrawerProps) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box component="nav" sx={{ width: { sm: drawerWidth }, height: '100%', flexShrink: { sm: 0 } }}>
      {/*Mobile top bar with drawer toggle and logo.*/}
      <AppBar
        position="static"
        sx={{
          display: { xs: 'flex', sm: 'none' },
          maxWidth: '100vw',
        }}
      >
        <Toolbar>
          <Link style={{ display: 'flex', alignItems: 'center' }} to={'/'}>
            <LogoNegative height={30} width={128} />
          </Link>
          <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="otevřít menu"
              sx={{ ml: 2 }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        anchor={'right'}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>{children}</Box>
      </Drawer>
      {/*Desktop drawer*/}
      <Drawer
        {...rest}
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          '& .MuiDrawer-paper::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        variant="permanent"
      >
        {children}
      </Drawer>
    </Box>
  );
};
